// extracted by mini-css-extract-plugin
var _1 = "LogoHeader_fffLogo__HwlUr";
var _2 = "LogoHeader_header__iowZH";
export { _1 as "fffLogo", _2 as "header" }
